import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useContext } from 'react';
import { LinkProviderContext, DEFAULT_LINK_TYPE } from '@lululemon/ecom-pattern-library-link-provider';

var LinkGenerator = /*#__PURE__*/React.forwardRef((props, ref) => {
  var Link = useContext(LinkProviderContext) || DEFAULT_LINK_TYPE;
  return /*#__PURE__*/React.createElement(Link, _extends({
    ref: ref
  }, props));
});

export { LinkGenerator };
//# sourceMappingURL=index.js.map
